var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_691_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 100C82.5097 100 104 78.5097 104 52C104 25.4903 82.5097 4 56 4C29.4903 4 8 25.4903 8 52C8 78.5097 29.4903 100 56 100Z",
    fill: "url(#paint0_linear_691_1651)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9988 98.4313C81.6417 98.4313 102.429 77.6436 102.429 52.0008C102.429 26.3579 81.6417 5.57031 55.9988 5.57031C30.356 5.57031 9.56836 26.3579 9.56836 52.0008C9.56836 77.6436 30.356 98.4313 55.9988 98.4313Z",
    fill: "#6F5C91"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_691_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8114 26.9653H64.2669L61.0645 30.1695C60.2351 30.9996 60.2362 32.344 61.0673 33.173C61.8967 33.9998 63.2432 34.0015 64.0736 33.1703L70.8936 26.3464C71.7346 25.5052 71.7235 24.1232 70.8449 23.297L64.0736 16.5218C63.2443 15.6917 61.8983 15.6906 61.0673 16.519C60.2362 17.348 60.2351 18.6924 61.0645 19.5225L64.258 22.718C54.6238 22.718 55.8253 22.7174 55.7201 22.7174C33.2444 22.7174 18.9777 47.151 30.248 66.7903C30.8315 67.8073 32.1299 68.1601 33.1497 67.5767C34.1684 66.9932 34.5206 65.6958 33.937 64.6782C24.2375 47.7764 36.6532 26.869 55.8114 26.9653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2487 37.5052C80.6652 36.4882 79.3657 36.1359 78.347 36.7188C77.3283 37.3022 76.9762 38.6002 77.5603 39.6178C87.1861 56.3913 75.0372 77.3308 55.7478 77.3308H47.2298L50.4322 74.1265C51.2621 73.2964 51.261 71.952 50.43 71.123C49.5989 70.2945 48.2524 70.2956 47.4231 71.1257L40.6031 77.9496C39.7693 78.7836 39.7649 80.1678 40.6546 81.0018L47.4231 87.7742C48.2524 88.6038 49.5984 88.606 50.43 87.777C51.261 86.948 51.2621 85.6036 50.4327 84.7735L47.2393 81.5781H55.7744C78.2617 81.5775 92.5167 57.1406 81.2487 37.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6223 45.7758H62.1264C63.3002 45.7758 64.2525 44.8246 64.2525 43.6522C64.2525 42.4792 63.3002 41.5285 62.1264 41.5285H57.8743V39.4049C57.8743 38.2319 56.9221 37.2812 55.7483 37.2812C54.574 37.2812 53.6223 38.2319 53.6223 39.4049V41.5285C50.1049 41.5285 47.2441 44.3866 47.2441 47.8995C47.2441 51.4123 50.1049 54.2704 53.6223 54.2704H57.8738C59.0464 54.2704 60.0004 55.2227 60.0004 56.3941C60.0004 57.5654 59.052 58.5183 57.8738 58.5183C55.6769 58.5183 55.7483 58.5177 55.7483 58.5177C55.745 58.5177 55.7417 58.5183 55.7383 58.5183C55.6558 58.5183 49.3226 58.5177 49.3702 58.5177C48.1959 58.5177 47.2441 59.4684 47.2441 60.6408C47.2436 61.8138 48.1953 62.7645 49.3696 62.765H53.6223V64.8887C53.6223 66.0611 54.574 67.0123 55.7483 67.0123C56.9221 67.0123 57.8743 66.0611 57.8743 64.8887V62.7656C61.3989 62.7656 64.2525 59.9169 64.2525 56.3941C64.2525 52.8812 61.3906 50.0231 57.8738 50.0231H53.6223C52.4496 50.0231 51.4962 49.0703 51.4962 47.8995C51.4962 46.7282 52.4496 45.7758 53.6223 45.7758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_691_1651",
    x: 0,
    y: 0,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_691_1651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_691_1651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_1651",
    x1: 85.8778,
    y1: 89.5611,
    x2: 26.1179,
    y2: 14.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_691_1651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.5688,
    height: 72.4871,
    fill: "white",
    transform: "translate(19.3613 16.0469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.c566bcc896a4df2fd077ecaff7d00386.svg";
export { ForwardRef as ReactComponent };